import React, { Component } from "react";
import CartContext from "./CartContext";
import { Table, Button, Modal, Form } from "react-bootstrap";
import axios from "axios";

export default class EmployeeHolidayCalendar extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      holidays: [],
      filteredHolidays: [],
      showModal: false,
      currentHoliday: { id: "", date: "", reasons: "", storeId: "" },
      isEdit: false,
      selectedYear: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchHolidays();
  }

  // Fetch holidays from API
  fetchHolidays = () => {
    axios
      .get(
        `${process.env.REACT_APP_API}EmployeeHolidayCalender/Store/${this.context.storeId}`
      )
      .then((res) => {
        const holidays = res.data;
        this.setState({ holidays, filteredHolidays: holidays });
      });
  };

  // Show modal for Add/Edit
  handleShowModal = (holiday = null) => {
    if (holiday) {
      this.setState({ currentHoliday: holiday, isEdit: true, showModal: true });
    } else {
      this.setState({
        currentHoliday: {
          id: "",
          date: "",
          reasons: "",
          storeId: this.context.storeId,
        },
        isEdit: false,
        showModal: true,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      currentHoliday: { ...this.state.currentHoliday, [name]: value },
    });
  };

  handleSave = () => {
    const { currentHoliday, isEdit } = this.state;

    // --- Validation ---
    if (!currentHoliday.date || !currentHoliday.reasons.trim()) {
      alert("Please enter both Date and Reasons.");
      return; // stop execution if invalid
    }

    const payload = {
      storeId: this.context.storeId,
      date: new Date(currentHoliday.date).toISOString(),
      reasons: currentHoliday.reasons,
    };

    if (isEdit) {
      axios
        .put(
          `${process.env.REACT_APP_API}EmployeeHolidayCalender/${currentHoliday.id}`,
          payload
        )
        .then(() => {
          this.fetchHolidays();
          this.handleCloseModal();
        })
        .catch((err) => {
          console.error(err);
          alert("Failed to update holiday.");
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_API}EmployeeHolidayCalender`, payload)
        .then(() => {
          this.fetchHolidays();
          this.handleCloseModal();
        })
        .catch((err) => {
          console.error(err);
          alert("Failed to add holiday.");
        });
    }
  };

  handleDelete = (id) => {
    if (window.confirm("Are you sure to delete this holiday?")) {
      axios
        .delete(`${process.env.REACT_APP_API}EmployeeHolidayCalender/${id}`)
        .then(() => {
          this.fetchHolidays();
        });
    }
  };

  // Generate year options for dropdown
  generateYearOptions = () => {
    const years = [];
    for (let y = 2000; y <= 2100; y++) {
      years.push(y);
    }
    return years;
  };

  // Handle year filter change
  handleYearChange = (e) => {
    const selectedYear = e.target.value;
    const { holidays } = this.state;

    const filteredHolidays = selectedYear
      ? holidays.filter(
          (h) => new Date(h.date).getFullYear() === parseInt(selectedYear)
        )
      : holidays;

    this.setState({ selectedYear, filteredHolidays });
  };

  // Print holidays (respects year filter)
  handlePrint = () => {
    const { filteredHolidays, selectedYear } = this.state;
    const sortedHolidays = [...filteredHolidays].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    const printWindow = window.open("", "_blank");
    const html = `
      <html>
        <head>
          <title>Employee Holiday List</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h3 { text-align: center; margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            @media print { button { display: none; } }
          </style>
        </head>
        <body>
          <h3>Employee Holiday List ${
            selectedYear ? ` - ${selectedYear}` : ""
          }</h3>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Reasons</th>
                <th>Store</th>
              </tr>
            </thead>
            <tbody>
              ${sortedHolidays
                .map(
                  (h) =>
                    `<tr>
                       <td>${new Date(h.date).toLocaleDateString()}</td>
                       <td>${h.reasons}</td>
                       <td>${h.store?.name || "-"}</td>
                     </tr>`
                )
                .join("")}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  render() {
    const { filteredHolidays, showModal, currentHoliday, selectedYear } =
      this.state;

    return (
      <div>
        <h3>
          <b>Employee Holiday Calendar</b>
        </h3>

        <div className="mb-3">
          <Button onClick={() => this.handleShowModal()}>Add Holiday</Button>{" "}
          <Button variant="info" onClick={this.handlePrint}>
            Print Holidays
          </Button>{" "}
          <Form.Group
            style={{
              width: "150px",
              display: "inline-block",
              marginLeft: "10px",
            }}
          >
            <Form.Label>Filter by Year</Form.Label>
            <Form.Control
              as="select"
              value={selectedYear}
              onChange={this.handleYearChange}
            >
              <option value="">All Years</option>
              {this.generateYearOptions().map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th width="10%">Date</th>
              <th width="70%">Reasons</th>
              <th width="20%">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredHolidays.map((h) => (
              <tr key={h.id}>
                <td>{new Date(h.date).toLocaleDateString()}</td>
                <td>{h.reasons}</td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => this.handleShowModal(h)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => this.handleDelete(h.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.isEdit ? "Edit Holiday" : "Add Holiday"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={
                    currentHoliday.date
                      ? new Date(currentHoliday.date)
                          .toISOString()
                          .substr(0, 10)
                      : ""
                  }
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Reasons</Form.Label>
                <Form.Control
                  type="text"
                  name="reasons"
                  value={currentHoliday.reasons || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
